import styled from 'styled-components'

export const SubHeader = styled.div`
  line-height: 2.5;
  font-weight: 600;
`
